import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// Paleta corporativa iTPV Manager:
// - primary: azul base de la marca
// - secondary: azul marino (drawer / encabezados)
// - accent / aqua: azul agua para contraste
// - Colores de acción (success/warning/error/info) más vivos para chips,
//   botones e iconos de estado.
const palette = {
  primary: '#0066CC',
  secondary: '#003366',
  accent: '#00BCD4',
  aqua: '#26C6DA',
  error: '#EF5350',
  info: '#29B6F6',
  success: '#2ECA71',
  warning: '#FFA726',
};

export default new Vuetify({
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: { ...palette, anchor: palette.primary },
      dark: { ...palette },
    },
  },
});
